import * as React from "react";
import { SVGProps } from "react";
const SvgToolkit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7V5h8v2h2V4a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v3h2ZM4 28h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2ZM4 9h24v17H4V9Zm17.059 12.469c-1.632 0-3.1-.989-3.716-2.5a1.066 1.066 0 0 1-.035-.1.93.93 0 0 0-.036-.1H8.104a1.321 1.321 0 0 1 0-2.642h9.173l.066-.2a4.016 4.016 0 0 1 7.255-.38l.025.051.024.051h-3.332l-.932 1.8.928 1.794h3.331l-.024.051-.024.051a4 4 0 0 1-3.535 2.124Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgToolkit;
